import React from 'react';

import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import ForParentsSchools from '../components/ForParentsSchools';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <link rel="canonical" href="https://www.lingu-pix.app/" />
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <ForParentsSchools />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
};

export default Home;